import {formattedPropertyModel, utils} from '@wallaby-ui/core';
import classNames from 'classnames';
import {isArray} from 'lodash';
import * as React from 'react';
import {useIntl} from 'react-intl';

import styles from './PropertiesMapItem.less';

interface OwnProps {
  isTranslated?: boolean;
  hideEmpty?: boolean;
  noPadding?: boolean;
  showBorders?: boolean;
  propertyValue?: any[] | any;
  propertyConfig: formattedPropertyModel.FormattedProperty;
}

type Props = OwnProps;
export const PropertiesMapItem: React.FC<Props> = (props) => {
  const {
    isTranslated,
    hideEmpty,
    noPadding,
    propertyConfig,
    propertyValue,
    showBorders,
  } = props;

  const intl = useIntl();
  const label =
    isTranslated &&
    utils.TranslateUtils.hasTranslation(propertyConfig.getLabel(), intl)
      ? utils.TranslateUtils.translate(propertyConfig.getLabel(), intl)
      : propertyConfig.getLabel();

  const i18nParams = propertyConfig.getI18nParams();
  const hide = hideEmpty && !propertyValue;
  return hide ? null : (
    <div
      className={classNames(styles.dlProperty, {
        [styles.dlPropertyBorder]: showBorders,
      })}
      data-name={'propertyWrapper'}
    >
      <span className={styles.dlPropertyKey} title={label} data-name={'label'}>
        {label}
      </span>
      <span className={styles.dlPropertyValues} data-name={'valuesWrapper'}>
        {isArray(propertyValue) ? (
          propertyValue.map((valueItem, idx) => {
            const value = i18nParams
              ? formattedPropertyModel.FormattedProperty.formatLabel(
                  valueItem.value,
                  intl,
                  valueItem,
                  i18nParams
                )
              : formattedPropertyModel.FormattedProperty.formatValue(
                  propertyConfig,
                  valueItem,
                  intl
                );
            return (
              <li
                // eslint-disable-next-line react/no-array-index-key
                key={idx}
                className={classNames(styles.dlPropertyValue, {
                  [styles.dlPropertyPadding]: !noPadding,
                })}
                title={value}
                data-name={'arrayItem'}
              >
                <span
                  className={styles.dlPropertyListItemValue}
                  data-name={'arrayValue'}
                >
                  {value}
                </span>
              </li>
            );
          })
        ) : (
          <span
            className={classNames(styles.dlPropertyValue, {
              [styles.dlPropertyPadding]: !noPadding,
            })}
            title={formattedPropertyModel.FormattedProperty.formatValue(
              propertyConfig,
              propertyValue,
              intl
            )}
            data-name={'value'}
          >
            {formattedPropertyModel.FormattedProperty.formatValue(
              propertyConfig,
              propertyValue,
              intl
            )}
          </span>
        )}
      </span>
    </div>
  );
};

PropertiesMapItem.displayName = 'PropertiesMapItem';
